module.exports = __webpack_public_path__ + "img/1.fd9a84a7.png";